/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualOwnFundDto } from '../../models/backend-actual-own-fund-dto';
import { BackendActualOwnFundRequestDto } from '../../models/backend-actual-own-fund-request-dto';

export interface MonitoringActualsOwnFundUpdate$FormData$Params {
  id: number;
  body: BackendActualOwnFundRequestDto;
}

export function monitoringActualsOwnFundUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsOwnFundUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsOwnFundUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualOwnFundDto>;
    }),
  );
}

monitoringActualsOwnFundUpdate$FormData.PATH = '/api/monitoring/actuals/own-fund/{id}/';
